module.exports = __webpack_public_path__ + "static/media/service_live-music-back.f303bfcc.jpg";